import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import moment from 'moment-timezone'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    date: new Date(),
    channel: {},
    timezone: moment.tz.guess(),
    timezone2: moment.tz.guess(),
    schedData: [],
    ready: false,
    filter: '',
    fullView: false
  },
  mutations: {
    setDate (state, date) {
      state.date = date
    },
    setChannel (state, channel) {
      state.channel = channel
    },
    setTimezone (state, tz) {
      state.timezone = tz
    },
    setSchedData (state, data) {
      state.schedData = data
    },
    setReady (state, ready) {
      state.ready = ready
    },
    setFilter (state, filter) {
      state.filter = filter
    },
    toggleView (state) {
      state.fullView = !state.fullView
    }
  },
  actions: {
    async fetchData (context, obj) {
      if (obj.date) {
        context.commit('setDate', obj.date)
      }

      if (obj.timezone) {
        context.commit('setTimezone', obj.timezone)
      }

      if (obj.channel) {
        context.commit('setChannel', obj.channel)
      }

      let r = await Axios.get(`https://api2-test.3abn.org/sched/daily/${genQuery(context.state)}`)
      context.commit('setReady', false)
      context.commit('setSchedData', addOnNowField(r.data.schedule))
      context.commit('setReady', true)
    }
  }
})

function genQuery (state) {
  const { channel, date, timezone, timezone2 } = state
  const d = moment.tz(date, timezone2).format('YYYY-MM-DD')
  const z = moment.tz(timezone).utcOffset()

  return `${channel.value}/${d}/${z}`
}

function addOnNowField (data2) {
  let data = []
  let d = data2
  for (let item of d) {
    (tempItem => {
      if (!(tempItem.length > 0 && tempItem.find(x => x.series_title === item.series_title) && tempItem.find(x => x.date === item.date))) data.push(item)
    })(data.filter(x => x.program_title === item.program_title))
  }
  const nowDate = Date.now()
  const firstDate = Date.parse(data[0].date)
  const lastDate = Date.parse(data[data.length - 1].date)
  const hourInMs = 3600000

  let onAirProg
  if ((firstDate <= nowDate) && ((lastDate + hourInMs) >= nowDate)) {
    const x = data.filter((e) => Date.parse(e.date) <= nowDate)
    onAirProg = x[x.length - 1]
  }

  let dataWithOnAir = data.map((e) => {
    return Object.assign({}, e, { on_air: e === onAirProg })
  })

  return dataWithOnAir
}
